export const blog = {
  title: "Blog",
  subtitle: "Fique por dentro das novidades em nosso blog",
  readMore: "Leia mais",
  latestPosts: "Últimos posts",
};
